module.exports = __webpack_public_path__ + "static/media/envio.bd30a7c1.jpg";